import React, { FC } from "react";

import { AiEmployeeConversationType } from "~/domains";

import { AiEmployeeConversationSender } from "~/domains/AiChatRoom";
import { AIAvatar, Avatar } from "~/ui";

type PropsType = {
  className?: string;
  conversation: AiEmployeeConversationType;
  currentEmployeeAvatarUrl: string;
};

export const ChatDetail: FC<PropsType> = ({
  conversation,
  currentEmployeeAvatarUrl,
  className = "",
}: PropsType) => {
  return (
    <div className={`flex ${className}`}>
      {conversation.senderType.type ===
      AiEmployeeConversationSender.assistant.type ? (
        <AIAvatar type="neutralExpression" size="sm" />
      ) : (
        <Avatar src={currentEmployeeAvatarUrl} size="sm" />
      )}
      <p className="whitespace-pre-wrap bg-secondary-200 rounded-xl ml-4 p-4">
        {conversation.message}
      </p>
    </div>
  );
};
